// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_contentCenter__ypDu8 {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.styles_wrapper__BShlJ {
  display: flex;
  flex-direction: column;
  gap: 48px;
  width: 100%;
  max-width: 334px;
}`, "",{"version":3,"sources":["webpack://./src/pages/LiquidityRemove/pageContent/contentCenterWrapper/styles.module.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;AACF","sourcesContent":[".contentCenter {\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.wrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 48px;\n  width: 100%;\n  max-width: 334px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"contentCenter": `styles_contentCenter__ypDu8`,
	"wrapper": `styles_wrapper__BShlJ`
};
export default ___CSS_LOADER_EXPORT___;
